import { AnimatedSprite, Texture } from "pixi.js"

import boom1 from './Explosion/boom1.png'
import boom2 from './Explosion/boom2.png'
import boom3 from './Explosion/boom3.png'
import boom4 from './Explosion/boom4.png'
import boom5 from './Explosion/boom5.png'
import boom6 from './Explosion/boom6.png'
import boom7 from './Explosion/boom7.png'
import boom8 from './Explosion/boom8.png'
import boom9 from './Explosion/boom9.png'
import boom10 from './Explosion/boom10.png'

import boom11 from './Explosion/boom11.png'
import boom12 from './Explosion/boom12.png'
import boom13 from './Explosion/boom13.png'
import boom14 from './Explosion/boom14.png'
import boom15 from './Explosion/boom15.png'
import boom16 from './Explosion/boom16.png'
import boom17 from './Explosion/boom17.png'
import boom18 from './Explosion/boom18.png'
import boom19 from './Explosion/boom19.png'
import boom20 from './Explosion/boom20.png'

import boom21 from './Explosion/boom21.png'
import boom22 from './Explosion/boom22.png'
import boom23 from './Explosion/boom23.png'
import boom24 from './Explosion/boom24.png'
import boom25 from './Explosion/boom25.png'
import boom26 from './Explosion/boom26.png'
import boom27 from './Explosion/boom27.png'
import boom28 from './Explosion/boom28.png'
import boom29 from './Explosion/boom29.png'
import boom30 from './Explosion/boom30.png'

import boom31 from './Explosion/boom31.png'
import boom32 from './Explosion/boom32.png'
import boom33 from './Explosion/boom33.png'
import boom34 from './Explosion/boom34.png'
import boom35 from './Explosion/boom35.png'
import boom36 from './Explosion/boom36.png'
import boom37 from './Explosion/boom37.png'
import boom38 from './Explosion/boom38.png'
import boom39 from './Explosion/boom39.png'
import boom40 from './Explosion/boom40.png'

import boom41 from './Explosion/boom41.png'
import boom42 from './Explosion/boom42.png'
import boom43 from './Explosion/boom43.png'
import boom44 from './Explosion/boom44.png'
import boom45 from './Explosion/boom45.png'
import boom46 from './Explosion/boom46.png'
import boom47 from './Explosion/boom47.png'
import boom48 from './Explosion/boom48.png'
import boom49 from './Explosion/boom49.png'
import boom50 from './Explosion/boom50.png'

import boom51 from './Explosion/boom51.png'
import boom52 from './Explosion/boom52.png'
import boom53 from './Explosion/boom53.png'
import boom54 from './Explosion/boom54.png'
import boom55 from './Explosion/boom55.png'
import boom56 from './Explosion/boom56.png'
import boom57 from './Explosion/boom57.png'
import boom58 from './Explosion/boom58.png'
import boom59 from './Explosion/boom59.png'
import boom60 from './Explosion/boom60.png'

import boom61 from './Explosion/boom61.png'
import boom62 from './Explosion/boom62.png'
import boom63 from './Explosion/boom63.png'
import boom64 from './Explosion/boom64.png'
import boom65 from './Explosion/boom65.png'
import boom66 from './Explosion/boom66.png'
import boom67 from './Explosion/boom67.png'
import boom68 from './Explosion/boom68.png'
import boom69 from './Explosion/boom69.png'

import boom70 from './Explosion/boom70.png'
import boom71 from './Explosion/boom71.png'
import boom72 from './Explosion/boom72.png'
export let boom: any


const bom1 = Texture.from(boom1)
const bom2 = Texture.from(boom2)
const bom3 = Texture.from(boom3)
const bom4 = Texture.from(boom4)
const bom5 = Texture.from(boom5)
const bom6 = Texture.from(boom6)
const bom7 = Texture.from(boom7)
const bom8 = Texture.from(boom8)
const bom9 = Texture.from(boom9)
const bom10 = Texture.from(boom10)

const bom11 = Texture.from(boom11)
const bom12 = Texture.from(boom12)
const bom13 = Texture.from(boom13)
const bom14 = Texture.from(boom14)
const bom15 = Texture.from(boom15)
const bom16 = Texture.from(boom16)
const bom17 = Texture.from(boom17)
const bom18 = Texture.from(boom18)
const bom19 = Texture.from(boom19)
const bom20 = Texture.from(boom20)

const bom21 = Texture.from(boom21)
const bom22 = Texture.from(boom22)
const bom23 = Texture.from(boom23)
const bom24 = Texture.from(boom24)
const bom25 = Texture.from(boom25)
const bom26 = Texture.from(boom26)
const bom27 = Texture.from(boom27)
const bom28 = Texture.from(boom28)
const bom29 = Texture.from(boom29)

const bom30 = Texture.from(boom30)
const bom31 = Texture.from(boom31)
const bom32 = Texture.from(boom32)
const bom33 = Texture.from(boom33)
const bom34 = Texture.from(boom34)
const bom35 = Texture.from(boom35)
const bom36 = Texture.from(boom36)
const bom37 = Texture.from(boom37)
const bom38 = Texture.from(boom38)
const bom39 = Texture.from(boom39)

const bom41 = Texture.from(boom41)
const bom42 = Texture.from(boom42)
const bom43 = Texture.from(boom43)
const bom44 = Texture.from(boom44)
const bom45 = Texture.from(boom45)
const bom46 = Texture.from(boom46)
const bom47 = Texture.from(boom47)
const bom48 = Texture.from(boom48)
const bom49 = Texture.from(boom49)
const bom40 = Texture.from(boom40)

const bom51 = Texture.from(boom51)
const bom52 = Texture.from(boom52)
const bom53 = Texture.from(boom53)
const bom54 = Texture.from(boom54)
const bom55 = Texture.from(boom55)
const bom56 = Texture.from(boom56)
const bom57 = Texture.from(boom57)
const bom58 = Texture.from(boom58)
const bom59 = Texture.from(boom59)
const bom50 = Texture.from(boom50)

const bom61 = Texture.from(boom61)
const bom62 = Texture.from(boom62)
const bom63 = Texture.from(boom63)
const bom64 = Texture.from(boom64)
const bom65 = Texture.from(boom65)
const bom66 = Texture.from(boom66)
const bom67 = Texture.from(boom67)
const bom68 = Texture.from(boom68)
const bom69 = Texture.from(boom69)
const bom60 = Texture.from(boom60)

const bom70 = Texture.from(boom70)
const bom71 = Texture.from(boom71)
const bom72 = Texture.from(boom72)





const textures = [bom1, bom2, bom3, bom4, bom5, bom6, bom7, bom8, bom9, bom10, bom11, bom12, bom13, bom14, bom15,
    bom16, bom17, bom18, bom19, bom20, bom21, bom22, bom23, bom24, bom25, bom26, bom27, bom28, bom29, bom30,
    bom31,
    bom32,
    bom33,
    bom34,
    bom35,
    bom36,
    bom37, bom38, bom39, bom40,
    bom41, bom42, bom43, bom44, bom45, bom46, bom47, bom48, bom49,
    bom50,
    bom51,
    bom52,
    bom53,
    bom54,
    bom55,
    bom56,
    bom57,
    bom58,
    bom59,

    bom60,
    bom61,
    bom62,
    bom63,
    bom64,
    bom65,
    bom66,
    bom67,
    bom68,
    bom69,

    bom70,
    bom71,
    bom72,
]
boom = new AnimatedSprite(textures)
boom.animationSpeed = .5
boom.anchor.set(.5, .5)
boom.scale.set(0.25)
boom.loop = false

